var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"scrollitem"},[_c('b-button',{staticClass:"cat-btn",class:_vm.activeCategory,attrs:{"id":_vm.categoryID},on:{"click":function($event){return _vm.selectCategory(_vm.category.id)}}},[_vm._v(_vm._s(_vm.category.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }